import {DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import {PatientDetailsConsent} from '@/features/patients/components/patient-details-consent/PatientDetailsConsent'
import {PatientExtended} from '@/features/patients/types'
import {formatDate} from '@/dayjs'
import {Text} from '@/components/ui/text/Text'

export const PatientDetailsPrivacyLegacy = ({patient}: {patient: PatientExtended}) => {
    const {t} = useTranslation()

    return (
        <DetailsFieldsSection title={t('patients:privacy_legacy')}>
            <Flexbox direction="column" gap={1}>
                <Flexbox gap={2} align="center">
                    {patient.privacyA && (
                        <PatientDetailsConsent value={patient.privacyA} label="patients:privacy_legacy_a" />
                    )}
                    {patient.privacyB && (
                        <PatientDetailsConsent value={patient.privacyB} label="patients:privacy_legacy_b" />
                    )}
                    {patient.privacyC && (
                        <PatientDetailsConsent value={patient.privacyC} label="patients:privacy_legacy_c" />
                    )}
                    {patient.privacyD && (
                        <PatientDetailsConsent value={patient.privacyD} label="patients:privacy_legacy_d" />
                    )}
                </Flexbox>
                {patient.consentDate && (
                    <Text size="textSm" palette="neutral" shade="500">
                        {t('patients:consent_date_value', {
                            date: formatDate(patient.consentDate, 'DD/MM/YYYY')
                        })}
                    </Text>
                )}
            </Flexbox>
        </DetailsFieldsSection>
    )
}
